<template>
  <b-columns is-multiline>
    <b-column class="is-full">
      <section>
        <h1 class="is-size-5">GHS Statements & Pictograms</h1>
        <agent-ghs-statements :statements="agentStatements" />
        <hr>
        <agent-ghs-pictograms :pictograms="agentPictograms" />
      </section>
    </b-column>
    <b-column class="is-full">
      <section>
        <h1 class="is-size-5 has-margin-bottom-small">Chemical attributes</h1>
        <div class="is-padded-small">
          <key-value-table :items="tableItems" />
          <agent-molecular-structure :image="selectedAgent.molecular_structure" />
        </div>
      </section>
    </b-column>
  </b-columns>
</template>

<script>
import AgentGhsStatements from './AgentGhsStatements'
import AgentGhsPictograms from './AgentGhsPictograms'
import KeyValueTable from '@/components/structures/KeyValueTable'
import AgentMolecularStructure from './AgentMolecularStructure'
import { mapGetters } from 'vuex'

export default {
  components: {
    AgentGhsStatements,
    AgentGhsPictograms,
    KeyValueTable,
    AgentMolecularStructure
  },
  computed: {
    ...mapGetters(['agentStatements', 'agentPictograms', 'selectedAgent']),
    tableItems () {
      /* eslint-disable */
      const { molecular_formula, smiles, molecular_weight, boiling_point, melting_point, flash_point, density, ld50,
        ph_min, ph_max, log_p, relative_vapour_density, vapour_pressure,
        pka, diffusivity_ratio, structure, lel, uel, odor_threshold, lc50, acgih_8h, acgih_stel, idlh, proton_affinity, hazard_id } = this.selectedAgent
      const opcw_schedule = this.selectedAgent.opcw_schedule ? this.selectedAgent.opcw_schedule.opcw_schedule : null
      const opcw_description = this.selectedAgent.opcw_schedule ? this.selectedAgent.opcw_schedule.opcw_description : null

      return [
        { label: 'Boiling point', value: boiling_point, unit: '°C' },
        { label: 'Melting point', value: melting_point, unit: '°C' },
        { label: 'Flash point', value: flash_point, unit: '°C' },
        { label: 'Density', value: density, unit: 'g/cm³ (25 °C)' },
        { label: 'Diffusivity ratio', value: diffusivity_ratio, unit: 'cm²/s (25 °C)' },
        { label: 'n-octanol-water partition ratio', value: log_p },
        { label: 'LD50', value: ld50 },
        { label: 'pH max', value: ph_max },
        { label: 'pH min', value: ph_min },
        { label: 'pKₐ', value: pka },
        { label: 'SMILES', value: smiles },
        { label: 'Relative vapour density', value: relative_vapour_density },
        { label: 'Vapour pressure', value: vapour_pressure, unit: 'kPa' },
        { label: 'OPCW schedule', value: opcw_schedule },
        { label: 'OPCW description', value: opcw_description },
        { label: 'Molecular formula', value: molecular_formula },
        { label: 'Molecular weight', value: molecular_weight, unit: 'g/mol' },
        { label: 'Structure', value: structure },
        { label: 'Lower Explosive Limit (LEL)', value: lel, unit: '%' },
        { label: 'Upper Explosive Limit (UEL)', value: uel, unit: '%' },
        { label: 'Odor threshold', value: odor_threshold, unit: 'ppm' },
        { label: 'LC50', value: lc50, unit: 'ppm' },
        { label: 'ACGIH 8h', value: acgih_8h, unit: 'ppm' },
        { label: 'ACGIH STEL', value: acgih_stel, unit: 'ppm' },
        { label: 'IDLH', value: idlh, unit: 'ppm' },
        { label: 'Proton Affinity', value: proton_affinity, unit: 'kJ/mole' },
        { label: 'Hazard ID Number', value: hazard_id },
      ]
    }
  }
}
</script>
